import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BotIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill={'transparent'}
      stroke={props.color ?? '#3379BD'}
      d="M11.921 13.502c4.237.068 8.305 2.09 9.327 5.657.1.346.004.665-.223.912A1.4 1.4 0 0 1 20 20.5H4c-.876 0-1.447-.694-1.28-1.361.957-3.82 4.97-5.705 9.201-5.637Zm-.008.5c-4.13-.066-7.83 1.77-8.707 5.254l-.058.234.147.193a.652.652 0 0 0 .04.047c.142.151.382.27.665.27h16a.969.969 0 0 0 .383-.078.826.826 0 0 0 .236-.152l.226-.21-.087-.296c-.95-3.235-4.717-5.196-8.845-5.262ZM7 3.5h3.75V4H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3.75v-.5H17A1.5 1.5 0 0 1 18.5 5v5a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 10V5A1.5 1.5 0 0 1 7 3.5Zm3 3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm4 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-2-4.75a.25.25 0 0 1 .25.25v.5h-.5V2a.25.25 0 0 1 .25-.25Z"
    />
  </Svg>
);
export default BotIcon;
